import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { MDBDataTable, MDBTableBody, MDBTableHead } from "mdbreact";
import Notiflix from "notiflix";
import PostApiCall from "../../Api";
import moment from "moment";

//import Charts


// Pages Components
import WelcomeComp from "./WelcomeComp";
import OrderGraph from "./OrderGraph";
import EnquiryGrid from "./EnquiryList";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

//i18n
import { withNamespaces } from 'react-i18next';


class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {

            UserDepartmentId: JSON.parse(localStorage.getItem("LoginDetail"))[0].fld_department,
            UserId: JSON.parse(localStorage.getItem("LoginDetail"))[0].fld_userid,

            OrderList: [],

            reports: [
                { title: "Orders", iconClass: "bx-copy-alt", description: "1,235" },
                { title: "Revenue", iconClass: "bx-archive-in", description: "$35, 723" },
                { title: "Average Price", iconClass: "bx-purchase-tag-alt", description: "$16.2" }
            ],
            email: [
                { title: "Week", linkto: "#", isActive: false },
                { title: "Month", linkto: "#", isActive: false },
                { title: "Year", linkto: "#", isActive: true }
            ],
            modal: false
        };
        this.togglemodal.bind(this);


    }




    componentDidMount() {

        Notiflix.Loading.Init({
            svgColor: "#777f80",
        });


        if (this.state.UserDepartmentId != "6") {

            this.fetchOrderForUser()

            let eventSource = new EventSource(`http://localhost:8091/updates/${this.state.UserDepartmentId}`);

            eventSource.addEventListener('connected', (e) => this.setState({ OrderList: JSON.parse(e.data) }));

        }
    }


    fetchOrderForUser() {

        Notiflix.Loading.Dots("Please wait...");

        PostApiCall.postRequest(
            {
                WhereClause: `where fld_department_id = ${this.state.UserDepartmentId} and fld_completion_date is null order by fld_order_id desc`,
            },
            "getpendingorderforuser"
        ).then((results) =>
            // const objs = JSON.parse(result._bodyText)
            results.json().then((obj) => {
                if (results.status == 200 || results.status == 201) {
                    // console.log(obj.data)
                    this.setState({
                        OrderList: obj.data,
                    });
                    Notiflix.Loading.Remove();
                }
            })
        )
    }





    togglemodal = () => {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }


    render() {

        // console.log(this.state.OrderList)

        if (this.state.UserDepartmentId == "6") {

            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>

                            {/* Render Breadcrumb */}
                            <Breadcrumbs title={('Kalanjiam Hardware Store')} breadcrumbItem={this.props.t('Dashboard')} />

                            <Row>
                                <Col xl="4">
                                    <WelcomeComp />

                                </Col>
                                <Col xl="8">
                                        <Card>
                                            <CardBody 
                                            style={{ height: '340px' }}
                                            >
                                                <OrderGraph />
                                            </CardBody>
                                        </Card>
                                </Col>
                            </Row>

                            <Row>
                                <Col xl="12">
                                    <EnquiryGrid />
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    {/* <LatestTranaction /> */}
                                </Col>
                            </Row>
                            
                        </Container>
                    </div>


                    {/* <Modal isOpen={this.state.modal} role="dialog" autoFocus={true} centered={true} className="exampleModal" tabindex="-1" toggle={this.togglemodal}>
                        <div className="modal-content">
                            <ModalHeader toggle={this.togglemodal}>
                                Order Details
                            </ModalHeader>
                            <ModalBody>
                                <p className="mb-2">Product id: <span className="text-primary">#SK2540</span></p>
                                <p className="mb-4">Billing Name: <span className="text-primary">Neal Matthews</span></p>
    
                                <div className="table-responsive">
                                    <Table className="table table-centered table-nowrap">
                                        <thead>
                                            <tr>
                                                <th scope="col">Product</th>
                                                <th scope="col">Product Name</th>
                                                <th scope="col">Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row">
                                                    <div>
                                                        <img src={modalimage1} alt="" className="avatar-sm" />
                                                    </div>
                                                </th>
                                                <td>
                                                    <div>
                                                        <h5 className="text-truncate font-size-14">Wireless Headphone (Black)</h5>
                                                        <p className="text-muted mb-0">$ 225 x 1</p>
                                                    </div>
                                                </td>
                                                <td>$ 255</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">
                                                    <div>
                                                        <img src={modalimage2} alt="" className="avatar-sm" />
                                                    </div>
                                                </th>
                                                <td>
                                                    <div>
                                                        <h5 className="text-truncate font-size-14">Hoodie (Blue)</h5>
                                                        <p className="text-muted mb-0">$ 145 x 1</p>
                                                    </div>
                                                </td>
                                                <td>$ 145</td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">
                                                    <h6 className="m-0 text-right">Sub Total:</h6>
                                                </td>
                                                <td>$ 400</td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">
                                                    <h6 className="m-0 text-right">Shipping:</h6>
                                                </td>
                                                <td>Free</td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">
                                                    <h6 className="m-0 text-right">Total:</h6>
                                                </td>
                                                <td>$ 400</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button type="button" color="secondary" onClick={this.togglemodal}>Close</Button>
                            </ModalFooter>
                        </div>
                    </Modal> */}
                </React.Fragment>
            );
        }

        else {

            const data = {
                columns: [
                    {
                        label: "S.No.",
                        field: "sn",
                        // sort: "asc",
                        width: 150,
                    },
                    {
                        label: "Order Number",
                        field: "ordernumber",
                        sort: "dsc",
                        width: 270,
                        
                    },
                    {
                        label: "Order Date / Time",
                        field: "orderdate",
                        sort: "disabled",
                        width: 200,
                    },
                    {
                        label: "Customer Code",
                        field: "code",
                        sort: "disabled",
                        width: 100,
                    },
                    {
                        label: "Name",
                        field: "name",
                        sort: "disabled",
                        width: 100,
                    },
                    {
                        label: "Mobile Number",
                        field: "number",
                        sort: "disabled",
                        width: 100,
                    },
                    {
                        label: "Address",
                        field: "address",
                        sort: "disabled",
                        width: 100,
                    },

                    {
                        label: "Order Status",
                        field: "orderstatus",
                        sort: "disabled",
                        width: 100,
                    },

                    {
                        label: "Action",
                        field: "action",
                        sort: "disabled",
                        width: 100,
                    },
                ],
                rows: this.state.OrderList.map((data, i) => {
                    // console.log(data)
                    return {
                        sn: (i + 1),
                        // orderid: data.fld_order_id,
                        ordernumber:data.fld_order_number,
                        // orderno: (data.fld_order_number),
                        orderdate: <span>
                             { moment(data.fld_order_date.split("T")[0]).format("DD/MM/YYYY")}<br />
                            {/* {data.fld_order_date.split("T")[0]}<br /> */}
                            {data.fld_order_date.split("T")[1].split(".")[0]}
                        </span>,
                        code: data.fld_customer_code,
                        name: (data.fld_customer_name),
                        number: (data.fld_customer_number),
                        address : data.fld_customer_address,
                        // items: (data.fld_no_of_items),
                        // value: (parseFloat(data.fld_order_amount).toFixed(2)),
                        // paymentstatus: (data.fld_payment_status),
                        orderstatus: (data.fld_status),
                        action: <input type="checkbox" onChange={() => {

                            PostApiCall.postRequest(
                                {
                                    orderid: data.fld_order_id,
                                    historyid: data.fld_history_id,
                                    userid: this.state.UserId
                                },
                                "updateorder"
                            ).then((results) =>
                                results.json().then((obj) => {
                                    if (results.status == 200 || results.status == 201) {
                                        Notiflix.Loading.Remove();
                                        Notiflix.Notify.Success("Data is successfully Updated/Added.");
                                        this.fetchOrderForUser()

                                    } else {
                                        Notiflix.Loading.Remove();
                                        Notiflix.Notify.Failure(obj.data);
                                    }
                                })
                            )
                        }} />

                    }
                })
            }


            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>

                            {/* Render Breadcrumb */}
                            <Breadcrumbs title={('Kalanjiam Hardware Store')} breadcrumbItem={this.props.t('Dashboard')} />


                            <MDBDataTable
                            style={{width:'200vw'}}
                            responsive
                                hover
                                // scrollY
                                striped
                                bordered
                                data={data}
                                seachTop={false}
                                entriesOptions={[10, 20, 40, 60, 80, 100, 120, 140]}
                            >

                                <MDBTableHead columns={data.columns} />
                                <MDBTableBody rows={data.rows} />
                            </MDBDataTable>



                        </Container>
                    </div>
                </React.Fragment>
            )
        }




    }
}

export default withNamespaces()(Dashboard);
